

export const SwitchToggle = ({valor, keyEdit, setEdit , disabled}) => {
    const changeToggle = (event) => {
        const isChecked = event.target.checked;
        keyEdit  ? setEdit(keyEdit, isChecked) : setEdit(isChecked)
    }
    return(
        <>
            <label className="switch" key={'switchToggle'}>
                <input
                    type="checkbox"
                    onChange={changeToggle}
                    checked={valor}
                    disabled={ disabled ? disabled : false}
                />
                <span className="slider round"></span>
            </label>
        </>
    )
}